module.exports = __webpack_public_path__ + "img/7_affordable_and_clean_energy.638bcf5c.svg";